import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import {
  bookingTypeEnumToTranslatedText,
  constructCalendarHighlights,
  convertJSDateToDotNetDateTimeDayEnd,
  convertJSDateToDotNetDateTimeDayStart,
  convertJSDateToDotNetDateTimeWithTime,
  differenceBetweenDatesAsDaysInteger,
  formattedAmountWithEuroCurrency,
  getAccommodationTranslationItem,
} from "../../common/misc";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  AddBookingOwnerNote,
  BookingContainer,
  BookingDetails,
  BookingItem,
  BookingsRequest,
  BookingType,
  getAccommodationsBookingsAsync,
  getBookingDetailsAsync,
  OwnerOwnBooking,
  OwnerOwnBookingNote,
  saveOwnerOwnBookingAsync,
  selectAccommodationsBookingItems,
  selectBookingItemsLoadingStatus,
  updateOwnerBookingAsync,
  UpdateOwnerOwnBooking,
} from "./bookingsSlice";
import {
  AvailableAccommodationListItem,
  BookingChangePossibleRequest,
  getIsBookingChangePossible,
  selectAccommodationsLoadingStatus,
  selectAvailableAccommodationsLoadingStatus,
  selectIsBookingChangePossibleStatus,
} from "../AccommodationsPage/accommodationsSlice";
import { LOADING_STATUS } from "../../common/constants";
import { useAuthUser } from "../../features/auth/authHooks";
import ReactDayPickerWrapper from "../../components/DayPicker/ReactDayPickerWrapper";
import ReactDatePicker from "react-datepicker";
import { DateRange } from "react-day-picker";
import { addStatusToast } from "../../components/StatusToast";
import { clearInputErrors } from "../../features/errors/errorsSlice";
import { forEach } from "react-bootstrap/ElementChildren";
import { AccommodationDetailsBasic } from "../AccommodationsPage/accommodationSlice";
import LocalizedDatePicker from "../../components/DatePicker/LocalizedDatePicker";
import { addDays } from "date-fns";

interface EditBookingModalWrapperProps {
  booking: BookingDetails;
  accommodation: AccommodationDetailsBasic;
  bookingStartDate: Date;
  bookingEndDate: Date;
  showModal: boolean;
  setParentShowBookingModal: Function;
  callParentInitFetch: Function;
}

const EditBookingModalWrapper: React.FC<EditBookingModalWrapperProps> = ({
  booking,
  accommodation,
  showModal,
  bookingStartDate,
  bookingEndDate,
  setParentShowBookingModal,
  callParentInitFetch,
}) => {
  if (booking == null) {
    return <></>;
  }

  let bookingAdults: number = 0;
  let bookingChildren: number = 0;
  booking.bookingOrderItems.map((bookingOrderItem) => {
    if (bookingOrderItem.orderItemType == 4) {
      return <></>;
    } else {
      bookingAdults = bookingOrderItem.amountOfAdults;
      bookingChildren = bookingOrderItem.amountOfChildren;
    }
  });
  const checkIfOwnerBookingIsPossibleStatus = useAppSelector(
    selectIsBookingChangePossibleStatus,
  );
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const [savingOwnerBooking, setSavingOwnerBooking] = useState(false);
  //const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => setParentShowBookingModal(false);
  const [ownerOwnBookingNote, setOwnerOwnBookingNote] = useState(
    booking?.ownerBookingNotes?.length > 0
      ? booking.ownerBookingNotes.map((note) => note.noteText).join("\n")
      : "",
  );
  const [ownerOwnBookingAdults, setOwnerOwnBookingAdults] =
    useState(bookingAdults);
  const [ownerOwnBookingChildren, setOwnerOwnBookingChildren] =
    useState(bookingChildren);
  const [ownerOwnBookingType, setOwnerOwnBookingType] = useState(
    booking.bookingType == BookingType.OwnerOwn
      ? "OwnerOwn"
      : "TemporaryDisabled",
  );
  const [availabilityCheckStatusMessage, setAvailabilityCheckStatusMessage] =
    useState("");
  const [
    availabilityCheckStatusBookingAllowed,
    setAvailabilityCheckStatusBookingAllowed,
  ] = useState(false);
  const [linenChecked, setLinenChecked] = useState(false);
  const [cleaningChecked, setCleaningChecked] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    from: bookingStartDate,
    to: bookingEndDate,
  });
  type BookingChangePossibleResponse = {
    bookingChangePossible: boolean;
  };
  const checkIfOwnerBookingIsPossible = () => {
    let bookingChangePossibleRequest: BookingChangePossibleRequest = new (class
      implements BookingChangePossibleRequest
    {
      accommodationId: string;
      existingBookingId: string;
      endDate: string;
      startDate: string;
    })();
    bookingChangePossibleRequest.accommodationId = accommodation.id;
    bookingChangePossibleRequest.existingBookingId = booking.id;
    bookingChangePossibleRequest.startDate =
      convertJSDateToDotNetDateTimeWithTime(selectedDateRange.from);
    bookingChangePossibleRequest.endDate =
      convertJSDateToDotNetDateTimeWithTime(selectedDateRange.to);
    dispatch(getIsBookingChangePossible(bookingChangePossibleRequest)).then(
      (res) => {
        const payload = res.payload as BookingChangePossibleResponse;
        if (
          res.meta.requestStatus === "fulfilled" &&
          payload.bookingChangePossible
        ) {
          setAvailabilityCheckStatusMessage("Varausta voidaan muuttaa!");
          setAvailabilityCheckStatusBookingAllowed(true);
          setIsSaveButtonEnabled(true);
        } else {
          setAvailabilityCheckStatusMessage("Varausta EI VOI muuttaa!");
          setAvailabilityCheckStatusBookingAllowed(false);
          setIsSaveButtonEnabled(false);
        }
      },
    );
  };
  const changeSelectedDates = (from?: Date, to?: Date) => {
    setSelectedDateRange((prev) => ({
      from: from ?? prev.from,
      to: to ?? prev.to,
    }));
    setIsSaveButtonEnabled(false);
  };
  const saveOwnerOwnBooking = () => {
    setSavingOwnerBooking(true);
    let ownerOwnBooking: UpdateOwnerOwnBooking = new (class
      implements OwnerOwnBooking
    {
      bookingId: string;
      ownerId: string;
      AccommodationId: string;
      ArrivalDateTime: string;
      DepartureDateTime: string;
      OwnerBookingNote: OwnerOwnBookingNote;
      Adults: number;
      Childs: number;
      BookingType: string;
    })();
    //Handle arrival and departure time
    selectedDateRange.from.setHours(16);
    selectedDateRange.from.setMinutes(0);
    selectedDateRange.from.setSeconds(0);
    selectedDateRange.to.setHours(12);
    selectedDateRange.to.setMinutes(0);
    selectedDateRange.to.setSeconds(0);
    ownerOwnBooking.bookingId = booking.id;
    ownerOwnBooking.ownerId = ownerAccountId;
    ownerOwnBooking.AccommodationId = accommodation.id;
    ownerOwnBooking.ArrivalDateTime = convertJSDateToDotNetDateTimeWithTime(
      selectedDateRange.from,
    );
    ownerOwnBooking.DepartureDateTime = convertJSDateToDotNetDateTimeWithTime(
      selectedDateRange.to,
    );
    ownerOwnBooking.OwnerBookingNote = new (class
      implements OwnerOwnBookingNote
    {
      NoteText: string;
    })();
    let numberOfPeopleInBooking =
      ownerOwnBookingAdults + ownerOwnBookingChildren;
    ownerOwnBooking.OwnerBookingNote.NoteText = "";
    if (linenChecked) {
      ownerOwnBooking.OwnerBookingNote.NoteText +=
        "Sisältää liinavaatteet " + numberOfPeopleInBooking + " kpl\n";
    }
    if (cleaningChecked) {
      ownerOwnBooking.OwnerBookingNote.NoteText += "Sisältää loppusiivouksen\n";
    }
    ownerOwnBooking.OwnerBookingNote.NoteText += ownerOwnBookingNote;
    ownerOwnBooking.Adults = ownerOwnBookingAdults;
    ownerOwnBooking.Childs = ownerOwnBookingChildren;
    ownerOwnBooking.BookingType = ownerOwnBookingType;
    //callParentInitFetch();
    //handleModalClose();

    dispatch(updateOwnerBookingAsync(ownerOwnBooking)).then((res) => {
      setSavingOwnerBooking(false);
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          addStatusToast({
            Message: `Omistajan oma varaus tallennettu!`,
          }),
        );
        if (callParentInitFetch != null) {
          callParentInitFetch();
        }
        handleModalClose();
      }
    });
  };
  let cabinName = getAccommodationTranslationItem(
    "fi_FI",
    "AccommodationName",
    accommodation,
  );
  return (
    <Modal show={showModal} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Varaus</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="d-grid gap-16">
            <Form.Group>
              <Form.Label>Kohde</Form.Label>
              <p className="mb-0" key={accommodation.id}>
                {accommodation.accommodationNumber} {cabinName}{" "}
                {/*formattedAmountWithEuroCurrency(accommodation.price)*/}
              </p>
            </Form.Group>

            <div className="d-flex  gap-8 align-items-center">
              <div className="w-100 position-relative">
                <Form.Label>Tulo</Form.Label>
                <LocalizedDatePicker
                  onChange={(date) => changeSelectedDates(date, null)}
                  selectsStart
                  selected={selectedDateRange.from}
                  className="form-control"
                  dateFormat="dd.MM.yyyy"
                />
                <Button
                  variant="link"
                  className="pe-none position-absolute end-0 bottom-0"
                  id="button-addon2"
                >
                  <span className="bi bi-calendar2-event"></span>
                </Button>
              </div>

              <div className="w-100 position-relative">
                <Form.Label>Lähtö</Form.Label>
                <LocalizedDatePicker
                  onChange={(date) => changeSelectedDates(null, date)}
                  selectsEnd
                  className="form-control"
                  selected={selectedDateRange.to}
                  dateFormat="dd.MM.yyyy"
                  minDate={
                    selectedDateRange.from
                      ? addDays(selectedDateRange.from, 1)
                      : undefined
                  }
                />
                <Button
                  variant="link"
                  className="pe-none position-absolute end-0 bottom-0"
                  id="button-addon2"
                >
                  <span className="bi bi-calendar2-event"></span>
                </Button>
              </div>
            </div>
            {/*
            <Form.Group>
              <Form.Select
                value={ownerOwnBookingType}
                onChange={(e) => setOwnerOwnBookingType(e.target.value)}
              >
                <option value="OwnerOwn">Omakäyttö</option>
                <option value="TemporaryDisabled">
                  Väliaikainen myynnistä poisto
                </option>
              </Form.Select>
            </Form.Group>
            */}
            <Row>
              <Col>
                <Form.Group
                  className="d-flex align-items-center"
                  style={{ gap: "1rem" }}
                >
                  <Button
                    variant="primary"
                    onClick={checkIfOwnerBookingIsPossible}
                  >
                    Tarkista saatavuus
                  </Button>
                  <span
                    className={`h5 text-${availabilityCheckStatusBookingAllowed ? "success" : "danger"}`}
                  >
                    {availabilityCheckStatusMessage}
                  </span>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Aikuisia</Form.Label>
                  <Form.Select
                    value={ownerOwnBookingAdults}
                    onChange={(e) => setOwnerOwnBookingAdults(+e.target.value)}
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Lapsia</Form.Label>
                  <Form.Select
                    value={ownerOwnBookingChildren}
                    onChange={(e) =>
                      setOwnerOwnBookingChildren(+e.target.value)
                    }
                  >
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {/*}
            <Form.Group>
              <Form.Label>Palvelut</Form.Label>
              <Form.Check
                label="Loppusiivous"
                className="mb-8"
                id="finalcleaning"
                onChange={() => setCleaningChecked(!cleaningChecked)}
              />
              <Form.Check
                label="Liinavaatteet"
                onChange={() => setLinenChecked(!linenChecked)}
                id="lining"
              />
            </Form.Group>
            {*/}
            <Form.Group>
              <Form.Label>Lisätiedot</Form.Label>
              <Form.Control
                as="textarea"
                onChange={(e) => setOwnerOwnBookingNote(e.target.value)}
                rows={3}
                value={ownerOwnBookingNote}
              />
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {checkIfOwnerBookingIsPossibleStatus == LOADING_STATUS.LOADING && (
          <>
            <Spinner animation="border" />
            <span>Tarkistetaan kohteen saatavuutta...</span>
          </>
        )}
        {checkIfOwnerBookingIsPossibleStatus != LOADING_STATUS.LOADING && (
          <>
            {savingOwnerBooking && (
              <>
                <Spinner animation="border" />
                Varausta tallennetaan...
              </>
            )}
            {!savingOwnerBooking && (
              <>
                <Button variant="outline-blue" onClick={handleModalClose}>
                  Peruuta
                </Button>
                <Button
                  variant="primary"
                  onClick={saveOwnerOwnBooking}
                  disabled={!isSaveButtonEnabled}
                >
                  Tallenna varaus
                </Button>
              </>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default EditBookingModalWrapper;
